export default {
  rentArrayLength: state => state.rentList.length,
  rentListInfo: state => PointerID => {
    var rentInfo = {};
    var rentArea = state.rentList.find(rentItem => rentItem.PointerID == PointerID); 
    if (rentArea){  
      if (rentArea.SoldInfo){
        rentInfo = rentArea.SoldInfo; 
      } 
    } 
    return rentInfo;
  },
  rezAreaInfo: state => RentID => state.rezAreaList.find(rentItem => rentItem.RentID == RentID),
  rezAreaList: state => state.rezAreaList.filter(x=> x.RentState == 1).slice().sort((x,y) => { return x.ExpireTime - y.ExpireTime }),
  rentList: (state, getters, rootState, rootGetters) =>
    state.rentList.filter(rentItem => {
      var disabledUser =
        "disabled" in state.rentFilter["filter_campus"]
          ? state.rentFilter["filter_campus"].disabled
          : false;
      var blocks = Object.keys(state.rentFilter["filter_blocks"]).map(
        i => state.rentFilter["filter_blocks"][i]
      );

      var blocks = Object.keys(state.rentFilter["filter_blocks"]).map(function(
        key
      ) {
        if (state.rentFilter["filter_blocks"][key]) return key;
      });
      blocks = blocks.filter(item => item != undefined);

      if (state.rentFilter["filter_style"] == "all") {  
        return (
          rentItem.PointerName.toString()
            .toLowerCase()
            .includes(state.rentSearchQuery.toLowerCase()) &&
          (!disabledUser || (disabledUser && rentItem.DisabledArea)) &&
          (!blocks.length ||
            blocks.some(el => rentItem.AreaID == el))
        );
      } else if (state.rentFilter["filter_style"] == "empty") {
        return (
          rentItem.PointerName.toString()
            .toLowerCase()
            .includes(state.rentSearchQuery.toLowerCase()) &&
          rentItem.PointerState == 0 &&
          (!disabledUser || (disabledUser && rentItem.DisabledArea)) &&
          (!blocks.length ||
            blocks.some(el => rentItem.AreaID == el))
        );
      } else if (state.rentFilter["filter_style"] == "full") {
        return (
          rentItem.PointerName.toString()
            .toLowerCase()
            .includes(state.rentSearchQuery.toLowerCase()) &&
          rentItem.PointerState == 2 &&
          (!disabledUser || (disabledUser && rentItem.DisabledArea)) &&
          (!blocks.length ||
            blocks.some(el => rentItem.AreaID == el))
        );
      }
      else if (state.rentFilter["filter_style"] == "rezerved") {
        return (
          rentItem.PointerName.toString()
            .toLowerCase()
            .includes(state.rentSearchQuery.toLowerCase()) &&
          rentItem.PointerState == 1 &&
          (!disabledUser || (disabledUser && rentItem.DisabledArea)) &&
          (!blocks.length ||
            blocks.some(el => rentItem.AreaID == el))
        );
      } 
    }).slice().sort((x,y) => { return x.PointerName - y.PointerName })
};
